<template>
	<div style="display: contents">
		<v-menu
			v-model="menu"
			bottom
			left
			offset-y
            content-class="round-card"
			transition="slide-y-transition"
			min-width="200">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					v-bind="attrs"
					v-on="on"
					:class="$eventBusUtility.iconAppBarColor">
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>

			<v-list dense class="background-2">
			<!-- Color Mode -->
			<v-list-item @click="toggleColorMode">
				<v-list-item-icon>
					<v-icon style="font-size: 18px">{{ $vuetify.theme.dark ? 'mdi-brightness-5' : 'mdi-weather-night' }}</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{ $vuetify.theme.dark ? 'Modalità Chiara' : 'Modalità Scura' }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<!-- Archive -->
			<v-list-item
				@click="goToArchive">
				<v-list-item-icon>
				<v-badge
					v-if="$store.getters.notificationsArchive && $store.getters.notificationsArchive.length > 0"
					:content="$store.getters.notificationsArchive.length"
					color="info"
					overlap>
					<v-icon style="font-size: 18px">mdi-folder-outline</v-icon>
				</v-badge>
					<v-icon style="font-size: 18px" v-else>mdi-folder-outline</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Archivio</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<!-- Daily Timecard -->
			<v-list-item
				v-if="$store.getters.checkModulePermissions('timecards')"
				@click="openTimecard">
				<v-list-item-icon>
					<v-icon style="font-size: 18px">mdi-alarm</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Timecard</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<!-- Timbra ora (self-service) -->
			<v-list-item
				v-if="canSelfClock"
				@click="openSelfClock">
				<v-list-item-icon>
					<v-icon style="font-size: 18px">mdi-fingerprint</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Timbra ora</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<!-- Releases - only show if there are news -->
			<v-list-item
				v-if="hasNews"
				@click="openReleases">
				<v-list-item-icon>
				<v-badge
					:content="newsCount"
					color="success"
					overlap>
					<v-icon style="font-size: 18px">mdi-new-box</v-icon>
				</v-badge>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Novità</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<!-- Sync -->
			<v-list-item
				v-if="$store.getters.checkModelPermissions('setting') && hasActiveIntegration"
				@click="openSync">
				<v-list-item-icon>
					<v-icon style="font-size: 18px">mdi-sync</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Sincronizzazione</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<!-- Bug Log -->
			<v-list-item
				v-if="$store.getters.checkModelPermissions('yellolog')"
				@click="goToLogs">
				<v-list-item-icon>
				<v-badge
					v-if="$store.getters.yellologsCount > 0"
					:content="$store.getters.yellologsCount > 99 ? '+99' : $store.getters.yellologsCount"
					color="red"
					overlap>
					<v-icon style="font-size: 18px">mdi-bug</v-icon>
				</v-badge>
					<v-icon style="font-size: 18px" v-else>mdi-bug</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Log Errori</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			</v-list>
		</v-menu>

		<!-- Hidden components that will be triggered -->
		<daily-timecard
			v-if="$store.getters.checkModulePermissions('timecards')"
			ref="dailyTimecard"
			:hide-activator="true"
		></daily-timecard>

		<releases-menu
			ref="releasesMenu"
			v-show="false"
		></releases-menu>

		<sync-menu
			v-if="$store.getters.checkModelPermissions('setting')"
			ref="syncMenu"
			v-show="false">
		</sync-menu>
	</div>
</template>

<script>
import DailyTimecard from '@/components/modules/timecards/DailyTimecard'
import ReleasesMenu from '@/components/common/ReleasesMenu'
import SyncMenu from '@/components/common/SyncMenu'

export default {
	name: 'MoreMenu',
	components: {
		DailyTimecard,
		ReleasesMenu,
		SyncMenu
	},

	data() {
		return {
			menu: false,
			hasNews: false,
			newsCount: 0,
			hasActiveIntegration: false
		}
	},

	computed: {
		canSelfClock() {
			const p = this.$store.getters.getProfile || {}
			return !!(p.hr_module_enabled && p.hr_employee_id)
		},
	},

	mounted() {
		// Check for news - same logic as ReleasesMenu
		if (this.$refs.releasesMenu && this.$refs.releasesMenu.news) {
			this.hasNews = this.$refs.releasesMenu.news.length > 0
			this.newsCount = this.$refs.releasesMenu.news.length
		}

		// Check for active integrations - same logic as SyncMenu
		this.hasActiveIntegration = this.$store.getters.getSetting('has_active_integration') || false
	},

	methods: {

		openSelfClock() {
			// Chiudi il menu prima di far aprire il dialog in App.vue
			this.menu = false
			this.$emit('openSelfClock')
		},

		toggleColorMode() {
			this.$vuetify.theme.dark = !this.$vuetify.theme.dark
			// Emit event to parent to update logo
			this.$emit('colorModeChanged')
			this.menu = false
		},
		
		openTimecard() {
			this.menu = false
			// Use nextTick to ensure menu is closed before opening timecard
			this.$nextTick(() => {
				if (this.$refs.dailyTimecard) {
				this.$refs.dailyTimecard.showDaily = true
				}
			})
		},

		openReleases() {
			this.menu = false
			this.$nextTick(() => {
				if (this.$refs.releasesMenu) {
				this.$refs.releasesMenu.showNews = true
				}
			})
		},

		openSync() {
			this.menu = false
			this.$nextTick(() => {
				if (this.$refs.syncMenu) {
				this.$refs.syncMenu.showSyncDialog = true
				}
			})
		},

		goToLogs() {
			this.menu = false
			this.$router.push({ name: 'yellologs' })
		},

		goToArchive() {
			this.menu = false
			this.$router.push({ path: '/profile/download/' })
		}
	}
}
</script>